function Loading() {
    return (
      <>
          <div className="">
            <div className="loader animate-spin"></div>
          </div>
      </>
    );
  }
  
  export default Loading;
  